import React from 'react';
import { Plus, Check } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CARD_STYLES = [
  { bg: 'bg-gradient-to-br from-orange-50 to-pink-50', border: 'border-orange-300', badge: 'bg-orange-500', price: 'text-orange-600', btn: 'bg-orange-500 hover:bg-orange-600' },
  { bg: 'bg-gradient-to-br from-violet-50 to-purple-50', border: 'border-violet-400', badge: 'bg-violet-600', price: 'text-violet-600', btn: 'bg-violet-600 hover:bg-violet-700' },
  { bg: 'bg-gradient-to-br from-pink-50 to-orange-50', border: 'border-pink-300', badge: 'bg-pink-500', price: 'text-pink-600', btn: 'bg-pink-500 hover:bg-pink-600' },
];

const PackageCard = ({ pkg, index, badgeLabel, bestValueIndex }) => {
  const { addToCart } = useCart();
  const style = CARD_STYLES[index % CARD_STYLES.length];

  return (
    <div
      className={`rounded-3xl p-6 border-4 shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all relative ${style.bg} ${style.border}`}
      data-testid={`package-card-${pkg.id}`}
    >
      {index === bestValueIndex && (
        <div className="absolute -top-3 -right-3 bg-yellow-400 text-purple-900 px-4 py-1 rounded-full font-bold text-sm shadow-lg transform rotate-12 z-10">
          BEST VALUE
        </div>
      )}
      {pkg.image && (
        <div className="relative overflow-hidden rounded-2xl aspect-[4/3] mb-4 bg-gray-50 -mx-2 -mt-2">
          <img src={pkg.image} alt={pkg.name} className="w-full h-full object-cover" loading="lazy" decoding="async" width="400" height="300" />
        </div>
      )}
      <div className={`text-white px-4 py-2 rounded-full inline-block mb-4 font-bold ${style.badge}`}>
        {badgeLabel}
      </div>
      <h3 className="text-xl sm:text-2xl font-bold heading-font mb-2" style={{ color: '#7C3AED' }}>
        {pkg.name}
      </h3>
      <div className={`text-3xl sm:text-4xl lg:text-5xl font-bold heading-font mb-4 ${style.price}`}>
        ${pkg.price.toFixed(2)}
      </div>
      <div className="bg-white rounded-2xl p-4 mb-6">
        <p className="font-semibold text-gray-800 mb-2">What's Included:</p>
        <ul className="space-y-2">
          {(pkg.items || []).map((item) => (
            <li key={item} className="flex items-center gap-2 text-gray-700">
              <Check size={16} className="text-green-500 flex-shrink-0" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
      <button
        onClick={() => addToCart(pkg)}
        className={`w-full text-white py-3 rounded-full font-bold text-lg shadow-lg flex items-center justify-center gap-2 hover:scale-105 active:scale-95 transition-all ${style.btn}`}
        data-testid={`add-package-${pkg.id}`}
      >
        <Plus size={20} /> Add to Cart
      </button>
    </div>
  );
};

export default PackageCard;
